export { Salesperson } from './interfaces/salesperson.interface';
export { SalespersonService } from './salesperson.service';
export { SalespersonServiceModule } from './salesperson.module';
